import { render, staticRenderFns } from "./FormNumberItem.vue?vue&type=template&id=b2cdb7e0&scoped=true"
import script from "./FormNumberItem.vue?vue&type=script&lang=js"
export * from "./FormNumberItem.vue?vue&type=script&lang=js"
import style0 from "./FormNumberItem.vue?vue&type=style&index=0&id=b2cdb7e0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2cdb7e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-pharmacy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2cdb7e0')) {
      api.createRecord('b2cdb7e0', component.options)
    } else {
      api.reload('b2cdb7e0', component.options)
    }
    module.hot.accept("./FormNumberItem.vue?vue&type=template&id=b2cdb7e0&scoped=true", function () {
      api.rerender('b2cdb7e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TkCommonPage/components/tableComp/formItems/FormNumberItem.vue"
export default component.exports